import {Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {Actions} from '@ngrx/effects';
import { AppState } from '../../..';


@Injectable()
export class UserEffects {


  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
  ) { }

}
